import CrudRepository from './CrudRepository'
export default class CommercialAppRepository extends CrudRepository {
  constructor () {
    super('customerCare/api/commercialApp/web')
  }
}
